import { DatePipe } from '@angular/common';
import { isValid } from 'date-fns';

declare global {
  interface Date {
    toUSDate(): string;
    toUSDatetime(): string;
    isEqualUpToMinute(otherDate: Date): boolean;
  }
}

/**
 * Extension method to convert date to US Date which can be used on an SQL sentence.
 * @returns string on 'yyyy-MM-dd' format.
 */
Date.prototype.toUSDate = function () {
  return new DatePipe('en-US').transform(this, 'yyyy-MM-dd').toString();
};

/**
 * Extension method to convert date to US Datetime
 * @returns string on 'yyyy-MM-dd:hh:mm:ss' format.
 */
Date.prototype.toUSDatetime = function () {
  return new DatePipe('en-US').transform(this, 'yyyy-MM-dd:hh:mm:ss').toString();
};

/** Returns true if the [otherDate] has the same year, month, day, hours and minutes */
Date.prototype.isEqualUpToMinute = function (this: Date, otherDate: Date): boolean {
  if (!isValid(otherDate)) {
    return false;
  }

  return (
    this.getFullYear() === otherDate.getFullYear() &&
    this.getMonth() === otherDate.getMonth() &&
    this.getDate() === otherDate.getDate() &&
    this.getHours() === otherDate.getHours() &&
    this.getMinutes() === otherDate.getMinutes()
  );
};
